export type Currency = 'AUD' | 'NZD' | 'USD'

const dollarCurrencies = ['AUD', 'NZD', 'USD'] as const

export const symbolForCurrency = (currency: Currency) => {
  if (dollarCurrencies.includes(currency)) {
    return '$'
  }

  return ''
}

export const countryForCurrency = (currency: Currency) => {
  switch (currency) {
    case 'AUD':
      return 'Australia'
    case 'NZD':
      return 'New Zealand'
    case 'USD':
      return 'the United States'
    default:
      return currency
  }
}
